// extracted by mini-css-extract-plugin
export default {"box":"models-page-header_box__1uw5R"};